module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game-summary"
  }, [_c('div', {
    staticClass: "blackBG-words"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [(_vm.results) ? _c('div', {
    staticClass: "played-words"
  }, [(_vm.results) ? _c('div', {
    staticClass: "backBtn",
    on: {
      "click": function($event) {
        _vm.results = false
      }
    }
  }, [_c('inline-svg', {
    staticClass: "cup-svg saveWord",
    attrs: {
      "src": require('../../assets/svg/back.svg').default
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t("game-new.game-summery.improve")))]), _vm._v(" "), _c('div', {
    staticClass: "divMistakes",
    style: ({
      textAlign: _vm.ltr ? 'left' : 'right'
    })
  }, [_vm._v("\n        " + _vm._s(_vm.$t("game-new.game-summery.mistakes")) + "\n      ")]), _vm._v(" "), _vm._l((_vm.orderedPlayedItems), function(word, idx) {
    return _c('div', {
      key: idx,
      staticClass: "word"
    }, [_c('div', {
      staticClass: "square",
      on: {
        "click": function($event) {
          return _vm.saveWord(word)
        }
      }
    }, [_c('inline-svg', {
      staticClass: "cup-svg saveWord",
      class: {
        savedWord: _vm.isSaved(word)
      },
      attrs: {
        "src": _vm.isSaved(word) ?
          require('../../assets/svg/saved.svg').default :
          require('../../assets/svg/notsaved.svg').default
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "audio"
    }, [_c('AudioBtn', {
      attrs: {
        "urlId": word.id
      }
    })], 1), _vm._v(" "), _c('div', {
      ref: "translations",
      refInFor: true,
      staticClass: "translations"
    }, [_c('div', {
      staticClass: "heb"
    }, [_vm._v(_vm._s(word.heb))]), _vm._v(" "), _c('div', {
      staticClass: "arbT arial"
    }, [_vm._v(_vm._s(word.Eng))]), _vm._v(" "), _c('div', {
      staticClass: "arb"
    }, [_vm._v(_vm._s(word.arb))])]), _vm._v(" "), _c('div', {
      staticClass: "square",
      class: {
        squareWrong: word.wrong
      }
    }, [_c('span', [_vm._v(_vm._s(word.wrong || "-"))])])])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.results) ? _c('div', [_c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.outText))]), _vm._v(" "), (_vm.audioSrc) ? _c('Spacer', {
    attrs: {
      "height": "12"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.audioSrc) ? _c('AudioPlayer', {
    attrs: {
      "audioSrc": _vm.audioSrc,
      "autoPlay": _vm.isAutoPlay
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vidSrc) ? _c('Spacer', {
    attrs: {
      "height": "12"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vidSrc) ? _c('VideoPlayer1', {
    attrs: {
      "vidSrc": _vm.makeLinkEmbaddable(_vm.vidSrc)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.imgSrc) ? _c('Spacer', {
    attrs: {
      "height": "12"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.imgSrc) ? _c('img', {
    attrs: {
      "id": "img",
      "src": _vm.imgSrc
    }
  }) : _vm._e(), _vm._v(" "), _c('Spacer', {
    attrs: {
      "height": "12"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.results) ? _c('div', {
    staticClass: "flex btnsDiv"
  }, [_c('button', {
    staticClass: "btnSummry btnRestart",
    on: {
      "click": _vm.restartGame
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("game-new.game-summery.again")) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btnSummry btnRes",
    on: {
      "click": function($event) {
        _vm.results = true
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("game-new.game-summery.improve")) + "\n      ")])]) : _vm._e(), _vm._v(" "), (!_vm.results) ? _c('button', {
    staticClass: "btnSummry btnGo",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("game-new.game-summery.next")) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21d42449","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Game-new/game-summary.vue
// module id = 398
// module chunks = 1 2